<template>
  <BoxedFrame
    title="Tickets and lists"
    allow-content-scroll="true"
  >
    <div class="w-612">
      <TicketsSection :form-id-prefix="ticketsFormIdPrefix" />
      <ListsSection :form-id-prefix="listsFormIdPrefix" />
      <TaxesSection />
    </div>
  </BoxedFrame>
</template>

<script setup lang="ts">
import BoxedFrame from '@/components/BoxedFrame.vue';
import TicketsSection from './TicketsSection.vue';
import ListsSection from './ListsSection.vue';
import TaxesSection from './TaxesSection.vue';

const ticketsFormIdPrefix = 'offer-sheets-tickets';
const listsFormIdPrefix = 'offer-sheets-lists';
</script>
